import { Box } from "@mui/material";
import React from "react";

const Header = ({ image, alt }) => {
  return (
    <>
      <Box
        sx={{
          position: "relative",
          overflow: "hidden",
          width: "100%",
          maxHeight: "800px",
          height: {
            xs: "300px",
            sm: "300px",
            md: "620px",
          },
          // mt: { xs: "9%", md: "6%", lg: "5%" },
        }}
      >
        <img
          src={image}
          alt={alt}
          style={{
            height: "100%",
            width: "100%",
            backgroundSize: "cover",
            backgroundPosition: "center",
            position: "relative",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        />
      </Box>
    </>
  );
};

export default Header;
